/* eslint-disable eqeqeq */
import React, { useState, useEffect } from "react";
import LazyLoad from "react-lazy-load";
import { useSelector } from "react-redux";
import {
  PlusIcon,
  VideoPlayIcon,
  TagClose,
} from "../../../Icons/icons.component";
import ArticleTags from "../ArticleTags";
import { FEED_DETAILS } from "../../../../constants/route-constants";
import { TagsListModal } from "../../TagsAndFavourites/Tags/TagsListModal";
import { unifiedEnvConfig } from "../../../../constants/api-endpoint";
import { httpDelete } from "../../../../utility/requestHelper";

import {
  DATE_FORMATS,
  LANGUAGE_CODES,
  VERTICALS,
} from "../../../../constants/app-constant";
import {
  formatDate,
  getUniqueValuesFromList,
} from "../../../../utility/common-methods";
const { V_BLOG, V_FORUM } = VERTICALS;

export default function BlogsAndForumFeedItem({
  feed,
  selectedFeeds,
  onFeedSelect,
  allArticleList,
  entityName,
  forEmbedArticles,
  updatedBulkSentiment,
  updatedBulkFavourite,
  clientId,
  updateSelectedTagsToFeeds,
}) {
  const updatedSentiment = updatedBulkSentiment;
  const updatedFavourite = updatedBulkFavourite;
  const {
    id,
    channel_type,
    thumbnail_link,
    comment_count,
    from_username,
    permalink,
    created_at,
    lang,
    title,
    name,
    page_details,
    tags,
    entityId,
    type,
  } = feed || {};

  const [showAddTagListModal, setShowAddTagListModal] = useState(false);
  const [tagsList, setTagsList] = useState([]);
  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};

  useEffect(() => {
    setTagsList(tags);
  }, [tags]);

  const { display_picture } = page_details || {};

  const handleFeedClick = () => {
    localStorage.setItem("articleIdList", JSON.stringify(allArticleList));
    window.open(
      `https://${window.location.host}${FEED_DETAILS}/bafad/${clientId}-${channel_type}/${id}?entityName="${entityName}"`,
      "_blank"
    );
  };

  const getAddedTag = (tags) => {
    setTagsList(getUniqueValuesFromList([...tagsList, ...tags], "tag_id"));
  };

  const renderTags = () => {
    if (tagsList && tagsList.length) {
      return tagsList.map((tag) => {
        const tagName = tag.tag_name || tag.name;
        return (
          <>
            <span className="tagName">
              {tagName}
              <span
                onClick={() => removeTagFromList(tag.tag_id)}
                className="tagClose"
              >
                <TagClose />
              </span>
            </span>
          </>
        );
      });
    }
    return null;
  };

  const removeTag = (tagObject) => {
    httpDelete(
      `${unifiedEnvConfig.DELETE_TAG_FROM_FEED.replace("{id}", id)}?client_id=${
        selectedClient.id
      }`,
      tagObject
    ).catch((err) => {
      console.log(err);
      alert("Couldn't delete the tag.");
    });
  };

  const removeTagFromList = (tagId) => {
    let tagForMainList = [];
    const tagObject =
      tagsList && tagsList.length
        ? tagsList
            .filter((i) => i.tag_id == tagId)
            .map((item) => {
              tagForMainList.push(item);
              return {
                tag_id: item.tag_id,
                social_feed_id: id,
                channel_type: channel_type,
              };
            })
        : [];
    setTagsList(tagsList.filter((i) => i.tag_id != tagId));
    updateSelectedTagsToFeeds(tagForMainList, true, entityId, id, type);
    removeTag(tagObject[0]);
  };

  const gotoPermalink = () => {
    if (!permalink) return;
    window.open(permalink, "_blank");
  };
  const isSingleFeedSelected = () => {
    const tempArr =
      selectedFeeds && selectedFeeds.filter((f) => f.id == feed.id);
    return tempArr && tempArr.length;
  };

  const pageTitle = channel_type == V_FORUM ? title : title;
  const selectedFeedWithTopic = { ...feed, topic_name: entityName };
  return (
    <div className="innerFeedItem socialFeedItem">
      {showAddTagListModal ? (
        <TagsListModal
          show={showAddTagListModal}
          onCancel={() => setShowAddTagListModal(false)}
          feedDetail={feed}
          addedTag={getAddedTag}
        />
      ) : null}
      <div className="headlineWrapper">
        <label className="inputWrap">
          <input
            type="checkbox"
            class="styled-checkbox"
            onChange={() =>
              onFeedSelect &&
              onFeedSelect(!isSingleFeedSelected(), selectedFeedWithTopic)
            }
            checked={isSingleFeedSelected()}
          />
          <span className="checkmark"></span>
        </label>
        <div className="feedInfoHeader">
          <div className="feedNamePic">
            {!forEmbedArticles && display_picture && (
              <img alt="Profile" src={display_picture} className="feedPic" />
            )}
            <span className="feedName clickable" onClick={handleFeedClick}>
              {pageTitle}
            </span>
          </div>
          {/* <span className="feedDivider"></span> */}
          {!forEmbedArticles && (
            <div className="feedChannelDate">
              <span className="newsDate"></span>
            </div>
          )}
        </div>
        {!forEmbedArticles && (
          <>
            <div className="rightContainer">
              <ul className="dropDownContainer">
                <ArticleTags
                  article={feed}
                  hideTheme
                  callSocialAPI
                  showFavouriteTag
                  updatedBulkSentiment={updatedSentiment}
                  updatedBulkFavourite={updatedFavourite}
                  isSingleFeedSelected={isSingleFeedSelected()}
                  isBlogAndForum
                />
              </ul>
            </div>
          </>
        )}{" "}
      </div>

      {/* <div className="feedDetails" onClick={handleFeedClick}>
        <Hashtags text={truncate(message)} />
      </div> */}

      {!forEmbedArticles && (
        <LazyLoad offsetVertical="1000">
          <>
            {thumbnail_link && (
              <div className="imgContainer videoContainer">
                <div className="videoThumb">
                  <VideoPlayIcon />
                  <a href={permalink} target="_blank" rel="noopener noreferrer">
                    <img src={thumbnail_link} alt="NA" />
                  </a>
                </div>
              </div>
            )}
          </>
        </LazyLoad>
      )}
      <div className="metaTagsWrap">
        <div className="mtWrap">
          <span className="label-span hoverable">
            {channel_type == V_BLOG && "Blog :"}
            {channel_type == V_FORUM && "Forum :"}
          </span>
          <span className="link" onClick={gotoPermalink}>
            {name || "NA"}
          </span>
        </div>
        <div className="mtWrap">
          <span className="label-span">Author :</span>{" "}
          <span>{from_username || "NA"}</span>
        </div>
        <div className="mtWrap">
          <span className="label-span">Language :</span>{" "}
          <span>{LANGUAGE_CODES[lang] || "NA"}</span>
        </div>
        <div className="mtWrap">
          <span className="label-span">Publish Date :</span>{" "}
          <span>
            {formatDate(new Date(created_at), DATE_FORMATS.DDMMYYYY_dash)}
          </span>
        </div>
        {!forEmbedArticles && (
          <>
            {channel_type == V_FORUM && (
              <div className="mtWrap">
                <span className="label-span">Comments :</span>{" "}
                <span>{comment_count}</span>
              </div>
            )}

            <div className="mtWrap mtAddTag">
              <span
                onClick={() => setShowAddTagListModal(true)}
                className="addTag"
              >
                Add Tag <PlusIcon />{" "}
              </span>
              <div className="tagList">{renderTags()}</div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
